import { Input } from '@eombor/ui';
import { MAX_RANGE_DAYS, isoDaysAgo, isoToday, type ReportRange } from '@eombor/contracts';
import { t } from '../../../shared/i18n/index.js';
import { Segmented } from '../../../shared/ui/Segmented.js';

/**
 * Tayyor davrlar. Ular sanani ALMASHTIRADI, alohida rejim ochmaydi —
 * shuning uchun «7 kun» bosilgach kalendarni qo'lda tuzatish mumkin va
 * ekranda ikkita bir-biriga zid boshqaruv paydo bo'lmaydi.
 */
const PRESETS = [7, 30, 90] as const;

type PresetKey = '7' | '30' | '90' | 'custom';

export interface RangePickerProps {
  value: ReportRange;
  onChange: (range: ReportRange) => void;
}

/** Tanlangan oraliq tayyor davrlardan biriga to'g'ri keladimi? */
const presetOf = (range: ReportRange): PresetKey => {
  if (range.to !== isoToday()) return 'custom';
  const found = PRESETS.find((days) => range.from === isoDaysAgo(days));
  return found === undefined ? 'custom' : (String(found) as PresetKey);
};

export const RangePicker = ({ value, onChange }: RangePickerProps) => {
  const active = presetOf(value);

  /* «Erkin» segmentini BOSIB bo'lmaydi: u tanlov emas, holat — kalendarda
     qo'lda kiritilgan sana shu segmentni o'zi yoqadi. Ro'yxatda esa u
     faqat tanlangan paytda ko'rinadi, aks holda "nima qiladi?" degan
     javobsiz tugma bo'lib qolardi. */
  const options = [
    ...PRESETS.map((days) => ({ value: String(days) as PresetKey, label: t('report.rangeDays', { days }) })),
    ...(active === 'custom' ? [{ value: 'custom' as PresetKey, label: t('report.rangeCustom') }] : []),
  ];

  return (
    <div className="flex flex-wrap items-end gap-3">
      <Segmented
        label={t('report.rangeLabel')}
        value={active}
        options={options}
        onChange={(next) => {
          if (next === 'custom') return;
          onChange({ from: isoDaysAgo(Number(next)), to: isoToday() });
        }}
      />

      <Input
        type="date"
        variant="filter"
        label={t('report.rangeFrom')}
        value={value.from}
        max={value.to}
        onChange={(event) => onChange({ ...value, from: event.target.value })}
      />
      <Input
        type="date"
        variant="filter"
        label={t('report.rangeTo')}
        value={value.to}
        min={value.from}
        max={isoToday()}
        onChange={(event) => onChange({ ...value, to: event.target.value })}
      />
    </div>
  );
};

/**
 * Sahifa ochilgandagi davr — oxirgi 30 kun.
 *
 * `MAX_RANGE_DAYS` shu yerda ATAYLAB eslatiladi: standart qiymat bir kun
 * o'zgarsa, u shartnomadagi chegaradan oshib ketmasligi kerak.
 */
export const DEFAULT_RANGE: ReportRange = {
  from: isoDaysAgo(Math.min(30, MAX_RANGE_DAYS)),
  to: isoToday(),
};
